// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getDatabase, ref, push, set, onValue, off } from "firebase/database";
import { MessageProps } from "../types";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

// Initialize Firebase
export const firebaseApp = initializeApp(firebaseConfig);
export const firebaseDatabase = getDatabase();

/**
 * Send a message to a conversation in Firebase Realtime Database
 */
export async function sendMessage(
  conversationID: string,
  message: MessageProps,
  isLessonChat: boolean = false
) {
  const path = isLessonChat
    ? `live-chats/${conversationID}`
    : `messages/${conversationID}`;
  const messagesRef = ref(firebaseDatabase, path);
  const newMessageRef = push(messagesRef);
  await set(newMessageRef, message);
}

/**
 * Subscribe to messages in a conversation. Returns an unsubscribe function.
 */
export function subscribeToMessages(
  conversationID: string,
  callback: (messages: MessageProps[]) => void,
  isLessonChat: boolean = false
) {
  const path = isLessonChat
    ? `live-chats/${conversationID}`
    : `messages/${conversationID}`;
  const messagesRef = ref(firebaseDatabase, path);
  const listener = onValue(messagesRef, (snapshot) => {
    const data = snapshot.val();
    const messages: MessageProps[] = data ? Object.values(data) : [];
    callback(messages);
  });
  return () => off(messagesRef, "value", listener);
}
